<template>
  <div>
    <el-table
      :data="licensing.data"
      :default-sort="{ prop: order_column, order: order_type }"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column label="User" prop="email" sortable></el-table-column>
      <el-table-column label="Track" prop="title" sortable></el-table-column>
      <el-table-column
        label="License key"
        prop="license_key"
        sortable
      ></el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="licensing.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, prev, pager, next, jumper"
      :total="licensing.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('youtubeLicensing', [
      'licensing',
      'loading',
      'order_column',
      'order_type',
      'page_size'
    ])
  },

  methods: {
    ...mapMutations('youtubeLicensing', ['setPage']),
    ...mapActions('youtubeLicensing', ['readLicensing']),
    currentChange(currentPage) {
      this.setPage(currentPage)
      this.readLicensing()
    },
    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readLicensing()
    },
  },

  created() {
    this.readLicensing()
  }
}
</script>
]
